import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDialog-paper": {
      borderRadius: "16px !important",
      overflow: "hidden",
      minHeight: "85vh",
      maxHeight: "92vh",
      minWidth: "85%",
      maxWidth: "90%",
      backgroundColor: "#ffffff",
    },
    "& .MuiDialogTitle-root": {
      backgroundColor: "#1a1a1a",
      color: "#fff",
      padding: "18px 24px",
    },
    "& .MuiDialogContent-root": {
      padding: "24px 28px",
    },
    "& .MuiDialogActions-root": {
      padding: "16px 28px",
      borderTop: "1px solid #f1f5f9",
      backgroundColor: "#ffffff",
    },
  },
  dialogTitleContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  title: {
    color: "#fff !important",
    fontWeight: "700 !important",
    fontSize: "18px !important",
    fontFamily: "'Inter', sans-serif !important",
  },
  closeIcon: {
    color: "#fff",
  },
  skipBtn: {
    "& .MuiButtonBase-root": {
      backgroundColor: "#ffffff",
      textTransform: "none",
      color: "#374151",
      borderRadius: 8,
      padding: "8px 20px",
      border: "1px solid #e5e7eb",
      fontWeight: 600,
      fontFamily: "'Inter', sans-serif",
      "&:hover": {
        backgroundColor: "#f9fafb",
      },
      marginRight: "10px",
    },
  },
  closeBtn: {
    "& .MuiButtonBase-root": {
      backgroundColor: "#ffffff",
      textTransform: "none",
      color: "#374151",
      borderRadius: 8,
      padding: "8px 20px",
      border: "1px solid #e5e7eb",
      fontWeight: 600,
      fontFamily: "'Inter', sans-serif",
      "&:hover": {
        backgroundColor: "#f9fafb",
      },
    },
  },
  submBtn: {
    "& .MuiButtonBase-root": {
      backgroundColor: "#1a1a1a",
      textTransform: "none",
      color: "#ffffff",
      borderRadius: 8,
      padding: "8px 24px",
      fontWeight: 600,
      fontFamily: "'Inter', sans-serif",
      "&:hover": {
        backgroundColor: "#333333",
      },
    },
  },
  tabWrapper: {
    borderBottom: "1px solid #e2e8f0",
    marginBottom: "20px",
    "& .MuiTab-root": {
      textTransform: "none",
      fontSize: "14px",
      fontWeight: 600,
      fontFamily: "'Inter', sans-serif",
      color: "#64748b",
      padding: "12px 20px",
      "&.Mui-selected": {
        color: "#0f172a",
      },
    },
    "& .MuiTabs-indicator": {
      backgroundColor: "#1a1a1a",
      height: "3px",
      borderRadius: "3px 3px 0 0",
    },
  },
  formInput: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      fontFamily: "'Inter', sans-serif",
      fontSize: "14px",
      backgroundColor: "#fff",
      "& fieldset": {
        borderColor: "#e5e7eb",
      },
      "&:hover fieldset": {
        borderColor: "#9ca3af",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#6b7280",
        borderWidth: "1px",
      },
    },
  },
}));

export default useStyles;
